import { CssThemes } from '../../common';
import { BlocEvent } from '../base-bloc';

export abstract class AppBlocEvent extends BlocEvent {}

// change user photo in the header
export class ChangeUserPhotoEvent extends AppBlocEvent {
  constructor(public userImageUrl: string) {
    super();
  }
}

export class LogoutEvent extends AppBlocEvent {}

export class InitApplicationTheme extends AppBlocEvent {}

export class UpdateAplicationTheme extends AppBlocEvent {
  constructor(public theme: CssThemes) {
    super();
  }
}